import React from "react"
import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {Sidebar} from './components/sidebar'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import { DynamicHeaderProvider, useDynamicHeader } from './core/DynamicHeaderContext'
import Popup from "src/components/Popup"

const HeaderRenderer: React.FC = () => {
    const { header } = useDynamicHeader()
    if (React.isValidElement(header)) {
        return header;
    }
    return null;
}

const MasterLayout = () => {
    const location = useLocation()
    useEffect(() => {
        reInitMenu()
    }, [location.key])

    return (
        <PageDataProvider>
            <DynamicHeaderProvider>
                <HeaderRenderer />
                <Popup />
                <div className="flex flex-1 w-full min-h-0" style={{height: 'calc(100dvh - 56px)'}}>
                    <Sidebar />
                    <div className="flex-1 min-w-0 h-full overflow-hidden" style={{ marginLeft: '94px' }}>
                        <Outlet />
                    </div>
                </div>
            </DynamicHeaderProvider>
        </PageDataProvider>
    )
}

export {MasterLayout}
